<script>
import WidgetCard from '@widgets/widget-card.vue'
import TimePerformance from '@components/charts/time-performance.vue'
import ResultsPerformance from '@components/charts/results-performance.vue'
import OpponentRankingPerformance from '@components/charts/opponent-ranking-performance.vue'
import FieldPositionPerformance from '@components/charts/field-position-performance.vue'
import PerformanceAgainsOpponents from '@components/charts/performance-against-opponents.vue'
import HomeAway from '@components/charts/home-away.vue'

export default {
  components: {
    WidgetCard,
    TimePerformance,
    ResultsPerformance,
    OpponentRankingPerformance,
    FieldPositionPerformance,
    PerformanceAgainsOpponents,
    HomeAway,
  },
  props: {
    graph: {
      type: String,
      default: '',
    },
    playerId: {
      type: Number,
      default: () => null,
    },
    sheetClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Graph',
    },
  },
  data() {
    return {
      loading: true,
    }
  },
}
</script>

<template>
  <WidgetCard
    :title="title"
    :sheet-class="[sheetClass, $style.doubleRowGrow]"
    :class="[$style.flex, $style.doubleRow]"
    :loading="loading"
  >
    <component
      :is="graph"
      v-show="!loading"
      :player-id="playerId"
      @loaded="loading = false"
    />
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.doubleRow {
  display: flex;
  flex-direction: column;
}

.doubleRowGrow {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
}
</style>
